import { 
    UPDATE_FILTER_DATE,
    CLEAR_RESUME_FILTER_DATES,
    SET_PROJECTS,
    UPDATE_MY_COMPETITIONS_FILTER_TYPE,
    UPDATE_PAGE_NEXT_PAGE,
    UPDATE_PROJECTS_LIST,
    UPDATE_MARBLES_NEXT_PAGE,
    SET_MARBLES_USER,
    LOAD_MORE_MARBLES,
    UPDATE_FILTER_DATE_ADMIN,
    UPDATE_ADMIN_MARBLE_STATE,
    ADMIN_MARBLES_NAME,
    UPDATE_MARBLES_PLANS,
    UPDATE_MARBLES_IN_PROJECTS,
    CLEAR_FILTER_MARBLES_ADMIN,
    SET_PROJECTS_ADMIN,
    UPDATE_PROJECTS_NEXT_PAGE,
    LOAD_MORE_PROJECTS_ADMIN,
    UPDATE_ADMIN_PROJECT_STATE,
    UPDATE_FILTER_PROJECTS_ADMIN,
    ADMIN_PROJECTS_NAME,
    CLEAR_FILTER_PROJECTS_ADMIN,
    UPDATE_COMPETITORS_QUANTITY,
} from './types'
import { 
    COMPETITIONS_OPEN, 
    COMPETITIONS_LOST, 
    COMPETITIONS_GAVEN_UP,
    COMPETITIONS_WON,
    PLAN_CODES,
    IN_COMPETITIONS_STATUS,
    COMPETITORS_QUANTITY
  } from '../global/enums'

const adminState = {
    resume_date: {
        initial_date: null,
        final_date: null,
    },
    marble: {
        types: [
            { name: 'Em aberto', selected: true, icon: 'pending', key: COMPETITIONS_OPEN },
            { name: 'Perdidas', selected: false, icon: 'sentiment_dissatisfied', key: COMPETITIONS_LOST },
            { name: 'Desistiu', selected: false, icon: 'pan_tool', key: COMPETITIONS_GAVEN_UP },
            { name: 'Venceu', selected: false, icon: 'sentiment_satisfied', key: COMPETITIONS_WON }
        ],
        limit: 20,
        page: 1,
        nextPage: null
    },
    marble_list_filter: {
        total: 0,
        limit: 10,
        page: 1,
        nextPage: null,
        marble_name: '',
        state: '',
        plans: [{
            selected: false,
            name: 'Free',
            value: PLAN_CODES.FREE_PLAN_CODE
          },
          {
            selected: false,
            name: 'Bronze',
            value: PLAN_CODES.MONTH_PLAN_CODE
          },
          {
            selected: false,
            name: 'Prata',
            value: PLAN_CODES.SEMESTER_PLAN_CODE
          },
          {
            selected: false,
            name: 'Ouro',
            value: PLAN_CODES.YEARLY_PLAN_CODE
          }],
        status:[
            {
                selected: false,
                name: 'Participando (mês)',
                value: IN_COMPETITIONS_STATUS.IN_COMPETITIONS
            },
            {
                selected: false,
                name: 'Não Participando (mês)',
                value: IN_COMPETITIONS_STATUS.NOT_IN_COMPETITIONS
            },
            {
                selected: false,
                name: 'Participou',
                value: IN_COMPETITIONS_STATUS.ON_COMPETITIONS
            },
            {
                selected: false,
                name: 'Não participou',
                value: IN_COMPETITIONS_STATUS.OFF_COMPETITIONS
            },
        ],
        dates: {
            initial_date: null,
            final_date: null,
        },
    },
    admin_projects_filter: {
        total: 0,
        limit: 10,
        page: 1,
        nextPage: null,
        project_name: '',
        state: '',
        competitors: [{
            selected: false,
            name: 'Sem participantes',
            value: COMPETITORS_QUANTITY.ZERO
          },
          {
            selected: false,
            name: '1 participante',
            value: COMPETITORS_QUANTITY.ONE
          },
          {
            selected: false,
            name: '2 participantes',
            value: COMPETITORS_QUANTITY.TWO
           },{
            selected: false,
            name: '3 participantes',
            value: COMPETITORS_QUANTITY.THREE
        }],
        dates: {
            initial_date: null,
            final_date: null,
        },
    },
    marble_projects: [],
    marble_list: [],
    admin_projects: []
}

const updateProjectList = (oldList, currentList) => {

    const result = [ ...oldList, ...currentList ]
  
    let filter = result.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)
  
    return filter
    
}

const updateFinal = ({ initial, date }, oldDate) => {

    if (!date) {
        return {
            initial_date: oldDate.initial_date,
            final_date: oldDate.final_date
        }
    }

    if (date && initial) {
        return {
            initial_date: date,
            final_date: oldDate.final_date
        }
    }

    if (date && date < oldDate.initial_date) {
        return { 
            initial_date: date,
            final_date: oldDate.initial_date
        }
    } 
    
    return {
        initial_date: oldDate.initial_date,
        final_date: date
    }
    
}

const adminReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {

        case UPDATE_PROJECTS_LIST: {
            return {
                ...state,
                marble_projects: updateProjectList(state.marble_projects, payload)
            }
        }

        case UPDATE_PAGE_NEXT_PAGE: {
            return {
              ...state,
              marble: {
                  ...state.marble,
                  page: payload.page,
                  nextPage: payload.nextPage
              }
            }
        }

        case UPDATE_MARBLES_NEXT_PAGE: {
            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    page: payload.page,
                    nextPage: payload.nextPage,
                    total: payload.total
                }
            }
        }

        case SET_MARBLES_USER: {
            return {
                ...state,
                marble_list: payload
            }
        }

        case LOAD_MORE_MARBLES: {
            return {
                ...state,
                marble_list: updateProjectList(state.marble_list, payload)
            }
        }

        case UPDATE_PROJECTS_NEXT_PAGE: {
            return {
                ...state,
                admin_projects_filter: {
                    ...state.admin_projects_filter,
                    page: payload.page,
                    nextPage: payload.nextPage,
                    total: payload.total
                }
            }
        }

        case UPDATE_ADMIN_PROJECT_STATE: {

            return {
                ...state,
                admin_projects_filter: {
                    ...state.admin_projects_filter,
                    state: payload
                }
            }

        }

        case UPDATE_FILTER_PROJECTS_ADMIN: {

            return {
                ...state,
                admin_projects_filter: {
                    ...state.admin_projects_filter,
                    dates: updateFinal(payload, state.admin_projects_filter.dates),
                }
            }

        }

        case SET_PROJECTS_ADMIN: {
            return {
                ...state,
                admin_projects: payload
            }
        }

        case LOAD_MORE_PROJECTS_ADMIN: {
            return {
                ...state,
                admin_projects: updateProjectList(state.admin_projects, payload)
            }
        }

        case SET_PROJECTS: {
            return {
                ...state,
                marble_projects: payload
            }
        }

        case ADMIN_PROJECTS_NAME: {
            return {
                ...state,
                admin_projects_filter: {
                    ...state.admin_projects_filter,
                    project_name: payload
                }
            }
        }

        case CLEAR_RESUME_FILTER_DATES: {
            return {
                ...state,
                resume_date: {
                    initial_date: null,
                    final_date: null,
                }
            }
        }

        case UPDATE_FILTER_DATE: {
            return {
                ...state,
                resume_date: updateFinal(payload, state.resume_date),
            }
        }

        case UPDATE_MY_COMPETITIONS_FILTER_TYPE: {
            return {
              ...state,
              marble: {
                ...state.marble,
                types: payload 
              }
            }
        }

        case UPDATE_FILTER_DATE_ADMIN: {
            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    dates: updateFinal(payload, state.marble_list_filter.dates),
                }
            }
        }

        case UPDATE_ADMIN_MARBLE_STATE: {

            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    state: payload
                }
            }

        }

        case ADMIN_MARBLES_NAME: {

            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    marble_name: payload
                }
            }

        }
        
        case UPDATE_MARBLES_PLANS: {

            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    plans: payload
                }
            }

        }

        case UPDATE_MARBLES_IN_PROJECTS: {

            return {
                ...state,
                marble_list_filter: {
                    ...state.marble_list_filter,
                    status: payload
                }
            }

        }

        case UPDATE_COMPETITORS_QUANTITY: {

            return {
                ...state,
                admin_projects_filter: {
                    ...state.admin_projects_filter,
                    competitors: payload
                }
            }

        }

        case CLEAR_FILTER_PROJECTS_ADMIN: {
            return {
                ...state,
                admin_projects_filter: {
                    total: 0,
                    limit: 10,
                    page: 1,
                    nextPage: null,
                    project_name: '',
                    state: '',
                    competitors: [{
                        selected: false,
                        name: 'Sem participantes',
                        value: COMPETITORS_QUANTITY.ZERO
                      },
                      {
                        selected: false,
                        name: '1 participante',
                        value: COMPETITORS_QUANTITY.ONE
                      },
                      {
                        selected: false,
                        name: '2 participantes',
                        value: COMPETITORS_QUANTITY.TWO
                       },{
                        selected: false,
                        name: '3 participantes',
                        value: COMPETITORS_QUANTITY.THREE
                    }],
                    dates: {
                        initial_date: null,
                        final_date: null,
                    },
                },
            }
        }

        case CLEAR_FILTER_MARBLES_ADMIN: {
            return {
                ...state,
                marble_list_filter: {
                    total: 0,
                    limit: 10,
                    page: 1,
                    nextPage: null,
                    marble_name: '',
                    state: '',
                    plans: [{
                        selected: false,
                        name: 'Free',
                        value: PLAN_CODES.FREE_PLAN_CODE
                      },
                      {
                        selected: false,
                        name: 'Bronze',
                        value: PLAN_CODES.MONTH_PLAN_CODE
                      },
                      {
                        selected: false,
                        name: 'Prata',
                        value: PLAN_CODES.SEMESTER_PLAN_CODE
                      },
                      {
                        selected: false,
                        name: 'Ouro',
                        value: PLAN_CODES.YEARLY_PLAN_CODE
                      }],
                    status:[
                        {
                            selected: false,
                            name: 'Participando (mês)',
                            value: IN_COMPETITIONS_STATUS.IN_COMPETITIONS
                        },
                        {
                            selected: false,
                            name: 'Não Participando (mês)',
                            value: IN_COMPETITIONS_STATUS.NOT_IN_COMPETITIONS
                        },
                        {
                            selected: false,
                            name: 'Participou',
                            value: IN_COMPETITIONS_STATUS.ON_COMPETITIONS
                        },
                        {
                            selected: false,
                            name: 'Não participou',
                            value: IN_COMPETITIONS_STATUS.OFF_COMPETITIONS
                        },
                    ],
                    dates: {
                        initial_date: null,
                        final_date: null,
                    },
                }
            }
        }

        default: {
          return state
        }
    }

}

export { adminReducer as default, adminState }